import React from 'react'

const IconsContext = React.createContext({})
export const IconsProvider = IconsContext.Provider
export default IconsContext
